import Vue from 'vue'
import Router from 'vue-router'
import shareHouse from '@/pages/shareHouse/shareHouse.vue'
import shareHousePreviewContract from '@/pages/shareHouse/previewContact.vue'
import LandLord from '@/pages/landlord/LandLord'
import DefaultPolicy from '@/pages/landlord/DefaultPolicy'
import MemberCenter from '@/pages/landlord/HouseStatusSubPages/MemberCenter'
import HouseStatus from '@/pages/landlord/HouseStatus'
import HouseStatusDefault from '@/pages/landlord/HouseStatusSubPages/HouseStatusDefault'
// 房東登入
import landlordLogin from '@/pages/landlord/login/login.vue'
// 房源管理
import HouseManagement from '@/pages/landlord/HouseManagementPages/HouseManagement'
import HouseManagementDefault from '@/pages/landlord/HouseManagementPages/HouseManagementDefault'
import HouseNewContract from '@/pages/landlord/HouseManagementPages/HouseNewContract'
import AddHouse from '@/pages/landlord/HouseManagementPages/AddHouse'
import EditHouse from '@/pages/landlord/HouseManagementPages/EditHouse'
import HouseDetailRented from '@/pages/landlord/HouseManagementPages/HouseDetailRented'
import BatchUpload from '@/pages/landlord/HouseManagementPages/BatchUpload'
import LandlordMapSearch from '@/pages/landlord/HouseManagementPages/LandlordMapSearch'
// 預定管理
import BookingManagement from '@/pages/landlord/BookingManagementPages/BookingManagement'
import BookingManagementDefault from '@/pages/landlord/BookingManagementPages/BookingManagementDefault'
// 租約管理
import LeaseManagement from '@/pages/landlord/LeaseManagementPages/LeaseManagement'
import LeaseManagementDefault from '@/pages/landlord/LeaseManagementPages/LeaseManagementDefault'
import ContractDetail from '@/pages/landlord/LeaseManagementPages/ContractDetail'
import ContractPaper from '@/pages/landlord/LeaseManagementPages/ContractPaper'
import contractPdf from '@/pages/landlord/LeaseManagementPages/contractPdf'
import BillDetail from '@/pages/landlord/LeaseManagementPages/BillDetail'

// 委託房客
import TaskManagement from '@/pages/landlord/TaskManagementPages/TaskManagement'
import TaskManagementDefault from '@/pages/landlord/TaskManagementPages/TaskManagementDefault'
import NewTask from '@/pages/landlord/TaskManagementPages/NewTask'
// 租客管理
import TenantManagement from '@/pages/landlord/tenantManagementPages/TenantManagement'
import TenantManagementDefault from '@/pages/landlord/tenantManagementPages/TenantManagementDefault'
// 財務管理
import FinancialManagement from '@/pages/landlord/financialManagementPages/financialManagement'
import FinancialManagementDefault from '@/pages/landlord/financialManagementPages/financialManagementDefault'
import FinancialAccountingBook from '@/pages/landlord/financialManagementPages/financialAccountingBook'
import FinancialBill from '@/pages/landlord/financialManagementPages/financialBill'


// 企業
import bussiness from '@/pages/bussiness/bussiness'
// 企業註冊
import bizLogin from '@/pages/bussiness/registerFlow/login'
import bizRegister from '@/pages/bussiness/registerFlow/register'
import bizSetPassword from '@/pages/bussiness/registerFlow/setPassword'
import bizUpdateSecrectSuccess from '@/pages/bussiness/registerFlow/updateSecrectSuccess'
import bizVerifiedEmail from '@/pages/bussiness/registerFlow/verifiedEmailHasSent'
import bizVerified from '@/pages/bussiness/registerFlow/bussinessVerified'
//個人首頁
import bizHomeFrame from '@/pages/bussiness/personalHome/homeFrame'
import bizHomeDefault from '@/pages/bussiness/personalHome/home/homeDefault'
import bizShortCut from '@/pages/bussiness/personalHome/home/shortCut'
import bizTodoListDefault from '@/pages/bussiness/personalHome/todoList/todoListDefault'
//管理分類
import bizMgtCategoryFrame from '@/pages/bussiness/mgtCategory/mgtCategoryFrame'
// 房源管理 //
import bizHouseMgtDefault from '@/pages/bussiness/mgtCategory/houseMgt/houseMgtDefault'
import bizAddHouse from '@/pages/bussiness/mgtCategory/houseMgt/AddHouse'
import bizEditHouse from '@/pages/bussiness/mgtCategory/houseMgt/EditHouse'
import bizViewHouse from '@/pages/bussiness/mgtCategory/houseMgt/viewHouse'
import bizEditPolicy from '@/pages/bussiness/mgtCategory/houseMgt/editPolicy'
import bizBatchUpload from '@/pages/bussiness/mgtCategory/houseMgt/BatchUpload'
import bizMapSearch from '@/pages/bussiness/mgtCategory/houseMgt/mapSearch'
import bizBatchPolicy from '@/pages/bussiness/mgtCategory/houseMgt/batchPolicy'
import bizBatchPublish from '@/pages/bussiness/mgtCategory/houseMgt/batchPublish'
import bizBatchDispatch from '@/pages/bussiness/mgtCategory/houseMgt/batchDispatch'
// 房源群組
import bizHouseGroupMgtDefault from '@/pages/bussiness/mgtCategory/houseGroupMgt/houseGroupMgtDefault'
import bizEditHouseGroup from '@/pages/bussiness/mgtCategory/houseGroupMgt/editHouseGroup'
// 預定管理 //
import bizBookingMgtDefault from '@/pages/bussiness/mgtCategory/bookingMgt/BookingMgtDefault'
import bizContractDefault from '@/pages/bussiness/mgtCategory/bookingMgt/bizContractDefault'
// 租約管理 //
import bizLeaseMgtDefault from '@/pages/bussiness/mgtCategory/leaseMgt/LeaseMgtDefault'
import bizBatchNotify from '@/pages/bussiness/mgtCategory/leaseMgt/batchNotify'
import bizNewPaperContract from '@/pages/bussiness/mgtCategory/leaseMgt/newPaperContractFrame'
import bizNewEContract from '@/pages/bussiness/mgtCategory/leaseMgt/newEContractFrame'
import bizPhoneSigned from '@/pages/bussiness/mgtCategory/leaseMgt/phoneSigned'
import bizNewBill from '@/pages/bussiness/financialReport/billMgt/newBill'
// 委託房客 //
import bizTaskMgtDefault from '@/pages/bussiness/mgtCategory/taskMgt/taskMgtDefault.vue'
import bizTaskPayment from '@/pages/bussiness/mgtCategory/taskMgt/taskPayment.vue'
import bizNewTask from '@/pages/bussiness/mgtCategory/taskMgt/newTask.vue'
// 屋主管理 //
import bizLandlordMgtDefault from '@/pages/bussiness/mgtCategory/landlordMgt/landlordMgtDefault.vue'
import bizAddLandlord from '@/pages/bussiness/mgtCategory/landlordMgt/addLandlord'
import bizEditLandlord from '@/pages/bussiness/mgtCategory/landlordMgt/editLandlord'
import bizViewLandlord from '@/pages/bussiness/mgtCategory/landlordMgt/viewLandlord'
// 收支報表 //
import bizFinancialReportFrame from '@/pages/bussiness/financialReport/financialReportFrame'
import bizReportOverview from '@/pages/bussiness/financialReport/reportOverview/reportOverviewDefault'
import bizBillMgt from '@/pages/bussiness/financialReport/billMgt/billMgtDefault'
import bizEditBill from '@/pages/bussiness/financialReport/billMgt/editBill'
import bizLedgerMgt from '@/pages/bussiness/financialReport/ledgerMgt/ledgerMgtDefault'
import bizNewLedger from '@/pages/bussiness/financialReport/ledgerMgt/newLedger'
import bizEditLedger from '@/pages/bussiness/financialReport/ledgerMgt/editLedger'
// 內部權限
import bizInternalAuthFrame from '@/pages/bussiness/internalAuth/internalAuthFrame'
import bizEmployeeRoleDefault from '@/pages/bussiness/internalAuth/employeeRole/employeeRoleDefault'
import bizAddEmployeeRole from '@/pages/bussiness/internalAuth/employeeRole/addEmployeeRole'
import bizEditEmployeeRole from '@/pages/bussiness/internalAuth/employeeRole/editEmployeeRole'
import bizViewEmployeeRole from '@/pages/bussiness/internalAuth/employeeRole/viewEmployeeRole'
import bizAccountMgtDefault from '@/pages/bussiness/internalAuth/accountMgt/accountMgtDefault'
import bizAddAccount from '@/pages/bussiness/internalAuth/accountMgt/addAccount'
import bizEditAccount from '@/pages/bussiness/internalAuth/accountMgt/editAccount'
import bizViewAccount from '@/pages/bussiness/internalAuth/accountMgt/viewAccount'
import bizOrganizationGroupDefault from '@/pages/bussiness/internalAuth/organizationGroup/organizationGroupDefault'
import bizAddOrganizationGroup from '@/pages/bussiness/internalAuth/organizationGroup/addOrganizationGroup'
import bizEditOrganizationGroup from '@/pages/bussiness/internalAuth/organizationGroup/editOrganizationGroup'
// 設置中心
import bizSettingCenterFrame from '@/pages/bussiness/settingCenter/settingCenterFrame'
import bizBussinessVerifiedDefault from '@/pages/bussiness/settingCenter/bussinessVerified/bussinessVerifiedDefault'
import bizContractSettingDefault from '@/pages/bussiness/settingCenter/contractSetting/contractSettingDefault'
import bizPreviewContract from '@/pages/bussiness/settingCenter/contractSetting/previewContract'
import bizIntrolDefault from '@/pages/bussiness/settingCenter/bussinessIntrol/bussinessIntrolDefault'
import bizWalletDefault from '@/pages/bussiness/settingCenter/wallet/walletDefault'
import bizElectReceiptDefault from '@/pages/bussiness/settingCenter/electReceipt/electReceiptDefault'
// 個人中心
import bizPersonalCenterFrame from '@/pages/bussiness/personalCenter/personalCenterFrame'
import bizPersonalCenterDefault from '@/pages/bussiness/personalCenter/personalCenterDefault'
// landingPage
import landingPage from '@/pages/officailPage/landingPage'
import home from '@/pages/officailPage/home/home'
import bizIntro from '@/pages/officailPage/bussiness/bussiness'
// 其他頁面
import bizDefaultPolicy from '@/pages/bussiness/otherPage/DefaultPolicy'
import bizFaq from '@/pages/bussiness/otherPage/faq'

import Faq from '@/pages/landlord/Faq'
import Login from '@/pages/Login'
import Search from '@/pages/Search'
import privateAndPolicy from '@/pages/landlord/PrivateAndPolicy'

// 會員條款 隱私權政策
import userTerms from '@/pages/officailPage/policyTerm/userTerms'
import privacyPolicy from '@/pages/officailPage/policyTerm/privacyPolicy'
import bizUserTerms from '@/pages/officailPage/policyTerm/bizUserTerms'
import bizPrivacyPolicy from '@/pages/officailPage/policyTerm/bizPrivacyPolicy'
// 洽談合作
import contact from '@/pages/officailPage/contact/contact'
// 文章
import article from '@/pages/officailPage/article/article'
import articleDetail from '@/pages/officailPage/article/articleDetail'
import articleDetail_1 from '@/pages/officailPage/article/articleDetail_1'
import articleDetail_2 from '@/pages/officailPage/article/articleDetail_2'
import articleDetail_3 from '@/pages/officailPage/article/articleDetail_3'
import articleDetail_4 from '@/pages/officailPage/article/articleDetail_4'
import articleDetail_5 from '@/pages/officailPage/article/articleDetail_5'
import articleDetail_6 from '@/pages/officailPage/article/articleDetail_6'

// 關於我們
import aboutUs from '@/pages/officailPage/aboutUs/aboutUs'
import binding from '@/pages/binding'
import liffRedirect from '@/pages/liffRedirect'


import MapSearch from '@/pages/MapSearch'
import store from '@/store';



Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: landingPage,
      meta: {
        title: '飛豬管家'
      },
      children: [
        {
          path: '',
          name: '',
          component: home,
          meta: {
            title: '飛豬管家'
          },
        },
        {
          path: 'enterpriseIntro',
          name: 'bizIntro',
          component: bizIntro,
          meta: {
            title: '飛豬管家'
          },
        },
        {
          path: 'article',
          name: 'article',
          component: article,
          // meta: {
          //   title: '文章列表'
          // },
        },
        // {
        //   path: 'article/articleDetail',
        //   name: 'articleDetail',
        //   component: articleDetail,
        //   // meta: {
        //   //   title: '文章內頁'
        //   // },
        // },
        {
          path: 'article/articleDetail_1',
          name: 'articleDetail_1',
          component: articleDetail_1,
          // meta: {
          //   title: '文章內頁_1'
          // },
        },
        {
          path: 'article/articleDetail_2',
          name: 'articleDetail_2',
          component: articleDetail_2,
          // meta: {
          //   title: '文章內頁_2'
          // },
        },
        {
          path: 'article/articleDetail_3',
          name: 'articleDetail_3',
          component: articleDetail_3,
          // meta: {
          //   title: '文章內頁_3'
          // },
        },
        {
          path: 'article/articleDetail_4',
          name: 'articleDetail_4',
          component: articleDetail_4,
          // meta: {
          //   title: '文章內頁_4'
          // },
        },
        {
          path: 'article/articleDetail_5',
          name: 'articleDetail_5',
          component: articleDetail_5,
          // meta: {
          //   title: '文章內頁_5'
          // },
        },
        {
          path: 'article/articleDetail_6',
          name: 'articleDetail_6',
          component: articleDetail_6,
          // meta: {
          //   title: '文章內頁_5'
          // },
        },
        {
          path: 'userTerms',
          name: 'userTerms',
          component: userTerms,
          // meta: {
          //   title: '會員條款'
          // },
        },
        {
          path: 'privacyPolicy',
          name: 'privacyPolicy',
          component: privacyPolicy,
          // meta: {
          //   title: '隱私權政策'
          // },
        },
        {
          path: 'bizUserTerms',
          name: 'bizUserTerms',
          component: bizUserTerms,
          // meta: {
          //   title: '企業版會員條款'
          // },
        },
        {
          path: 'bizPrivacyPolicy',
          name: 'bizPrivacyPolicy',
          component: bizPrivacyPolicy,
          // meta: {
          //   title: '企業版隱私權政策'
          // },
        },
        {
          path: 'contact',
          name: 'contact',
          component: contact,
          // meta: {
          //   title: '洽談合作'
          // },
        },
        {
          path: 'aboutUs',
          name: 'aboutUs',
          component: aboutUs,
          // meta: {
          //   title: '關於我們'
          // },
        },
      ]
    },
    {
      path: '/binding',
      name: 'binding',
      component: binding,
      meta: {
        title: '飛豬管家',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/liffRedirect',
      name: 'liffRedirect',
      component: liffRedirect,
      meta: {
        title: '飛豬管家',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: '飛豬管家',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/search',
      name: 'Search',
      component: Search,
      meta: {
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/mapsearch',
      name: 'LandlordMapSearch',
      component: LandlordMapSearch,
      meta: {
        title: '房源管理-地圖搜尋',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/private',
      name: 'privateAndPolicy',
      component: privateAndPolicy,
      meta: {
        title: '隱私權政策',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/contractPaper',
      name: 'contractPaper',
      component: ContractPaper,
      meta: {
        title: '查看合約',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/contractPdf',
      name: 'contractPdf',
      component: contractPdf,
      meta: {
        title: '查看紙本合約',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/defaultpolicy',
      name: 'defaultpolicy',
      component: DefaultPolicy,
      meta: {
        title: '預設合約',
        channel: 'WEB_LANDLORD'
      }
    },
    {
      path: '/shareHouse',
      name: 'shareHouse',
      component: shareHouse,
      meta: {
        channel: 'WEB_TENANT'
      }
    },
    {
      path: '/shareHouse/previewContract',
      name: 'shareHousePreviewContract',
      component: shareHousePreviewContract,
      meta: {
        title: '預覽合約',
        channel: 'WEB_TENANT'
      }
    },
    {
      path: '/landlord',
      name: 'landlord',
      component: LandLord,
      meta: {
          requiresAuth: true,
          channel: 'WEB_LANDLORD'
        },
      children: [
        // {
        //   path: '/',
        //   component: HouseStatus,
        // },
        {
          path: 'housestatus',
          component: HouseStatus,
          children: [
            {
              path: 'home',
              name: 'housestatusdefault',
              component: HouseStatusDefault,
              meta: {
                title: '房態首頁',
                channel: 'WEB_LANDLORD'
              }
            },
            {
              path: 'newcontract',
              name: 'newcontract',
              component: HouseNewContract,
              meta: {
                title: '新增紙本合約',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                isVerified: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: '/landlord/leasemanagement/home'
                  },
                  {
                    name: '新增紙本合約'
                  }
                ]
              },
            },
            {
              path: 'addhouse',
              name: 'addhouse',
              component: AddHouse,
              meta: {
                title: '刊登廣告',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                // isVerified: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: '/landlord/housemgt/home'
                  },
                  {
                    name: '刊登廣告'
                  }
                ]
              },
            },
            {
              path: 'editHouse',
              name: 'editHouse',
              component: EditHouse,
              meta: {
                title: '編輯房源',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: '/landlord/housemgt/home'
                  },
                  {
                    name: '編輯房源'
                  }
                ]
              },
            },
            {
              path: 'houseDetail',
              name: 'houseDetail',
              component: HouseDetailRented,
              meta: {
                title: '房源詳情',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: '/landlord/housemgt/home'
                  },
                  {
                    name: '房源詳情'
                  }
                ]
              },
            },
            {
              path: 'batch',
              name: 'batchUpload',
              component: BatchUpload,
              meta: {
                title: '批次新增',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                isVerified: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: '/landlord/housemgt/home'
                  },
                  {
                    name: '批次新增'
                  }
                ]
              },
            },
            {
              path: 'member',
              name: 'MemberCenter',
              component: MemberCenter,
              meta: {
                title: '會員中心',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '房態首頁',
                    link: 'home'
                  },
                  {
                    name: '會員中心'
                  }
                ]
              },
            },
          ]
        },
        {
          path: 'housemgt',
          name: 'housemgt',
          component: HouseManagement,
          children: [
            {
              path: 'home',
              name: 'HouseManagementDefault',
              component: HouseManagementDefault,
              meta: {
                title: '房源管理',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
          ],
          meta: {
            isFixed: true,
          },
        },
        {
          path: 'tenantRecommendMgt',
          name: 'tenantRecommendMgt',
          component: () => import('@/pages/landlord/tenantRecommandManagementPages/TenantRecommandManagement.vue'),
          children: [
            {
              path: 'home',
              name: 'tenantRecommendMgtDefault',
              component: () => import('@/pages/landlord/tenantRecommandManagementPages/TenantRacommandManagementDefault.vue'),
              meta: {
                title: '推薦房客',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
          ],
          meta: {
            isFixed: true,
          },
        },
        {
          path: 'bookingmgt',
          name: 'bookingmgt',
          component: BookingManagement,
          children: [
            {
              path: 'home',
              name: 'BookingManagementdefault',
              component: BookingManagementDefault,
              meta: {
                title: '預定管理',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
          ],
          meta: {
            isFixed: true,
          },
        },
        {
          path: 'leasemanagement',
          name: 'leasemanagement',
          component: LeaseManagement,
          children: [
            {
              path: 'home',
              name: 'leasemanagementdefault',
              component: LeaseManagementDefault,
              meta: {
                title: '租約管理',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
            {
              path: 'meterRecord',
              name: 'meterRecord',
              component: () => import('@/pages/landlord/LeaseManagementPages/meterRecord.vue'),
              meta: {
                title: '房客拍表紀錄',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: '/landlord/leasemanagement/home'
                  },
                  {
                    name: '房客拍表紀錄',
                  }
                ]
              },
            },
            {
              path: 'BillDetail',
              name: 'BillDetail',
              component: BillDetail,
              meta: {
                title: '帳單紀錄',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: '/landlord/leasemanagement/home'
                  },
                  {
                    name: '帳單紀錄'
                  }
                ]
              },
            },
            {
              path: 'contractVersion',
              name: 'contractVersion',
              component: () => import('@/pages/landlord/LeaseManagementPages/contractVersion.vue'),
              meta: {
                title: '合約版本',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: '/landlord/leasemanagement/home'
                  },
                  {
                    name: '合約版本',
                  }
                ]
              },
            },
          ],
          meta: {
            channel: 'WEB_LANDLORD',
            breadcrumb: [
              {
                name: '房態首頁',
                link: 'housestatus'
              },
              {
                name: '房源管理'
              }
            ]
          },
        },
        {
          path: 'tenantmanagement',
          name: 'tenantmanagement',
          component: TenantManagement,
          children: [
            {
              path: 'home',
              name: 'tenantManagementDefault',
              component: TenantManagementDefault,
              meta: {
                title: '租客管理',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
          ],
          meta: {
            channel: 'WEB_LANDLORD',
            breadcrumb: [
              {
                name: '房態首頁',
                link: 'housestatus'
              },
              {
                name: '租客管理'
              }
            ]
          },
        },
        {
          path: 'financialmanagement',
          name: 'financialmanagement',
          component: FinancialManagement,
          children: [
            {
              path: 'home',
              name: 'financialManagementDefault',
              component: FinancialManagementDefault,
              meta: {
                title: '收支報表',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
            {
              path: 'financialAccountingBook',
              name: 'financialAccountingBook',
              component: FinancialAccountingBook,
              meta: {
                title: '記帳本',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '收支報表',
                    link: '/landlord/financialmanagement/home'
                  },
                  {
                    name: '記帳本'
                  }
                ]
              }
            },
            {
              path: 'financialBill',
              name: 'financialBill',
              component: FinancialBill,
              meta: {
                title: '帳單列表',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                breadcrumb: [
                  {
                    name: '收支報表',
                    link: '/landlord/financialmanagement/home'
                  },
                  {
                    name: '帳單列表'
                  }
                ]
              }
            },
          ],
          meta: {
            channel: 'WEB_LANDLORD',
            breadcrumb: [
              {
                name: '房態首頁',
                link: 'housestatus'
              },
              {
                name: '租客管理'
              }
            ]
          },
        },
        {
          path: 'faq',
          name: 'Faq',
          component: Faq,
          meta: {
            title: '常見問題',
            channel: 'WEB_LANDLORD',
          }
        },
        {
          path: 'taskmgt',
          name: 'taskmgt',
          component: TaskManagement,
          children: [
            {
              path: 'home',
              name: 'TaskManagementdefault',
              component: TaskManagementDefault,
              meta: {
                title: '委託房客',
                channel: 'WEB_LANDLORD',
                isFixed: true
              }
            },
            {
              path: 'newtask',
              name: 'NewTask',
              component: NewTask,
              meta: {
                title: '新增委託',
                channel: 'WEB_LANDLORD',
                isFixed: true,
                isVerified: true,
                breadcrumb: [
                  {
                    name: '委託房客',
                    link: '/landlord/taskmgt/home'
                  },
                  {
                    name: '新增委託'
                  }
                ]
              }
            },
          ],
          meta: {
            isFixed: true,
            channel: 'WEB_LANDLORD',
          },
        },
      ]
    },
    {
      path: '/landlord/login',
      name: 'landlordLogin',
      component: landlordLogin,
      meta: {
        channel: 'WEB_LANDLORD',
      },
    },
    {
      path: '/enterprise',
      name: 'bussiness',
      component: bussiness,
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: 'personalHome/myHome',
          name: '',
          component: bizHomeFrame,
          children: [
            {
              path: '',
              name: 'bizHomeDefault',
              component: bizHomeDefault,
              meta: {
                title: '我的首頁',
                channel: 'WEB_COMPANY',
              }
            },
            {
              path: 'shortCut',
              name: 'bizShortCut',
              component: bizShortCut,
              meta: {
                title: '快速操作',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '我的首頁',
                    link: 'bizHomeDefault'
                  },
                  {
                    name: '快速操作'
                  }
                ]
              }
            },

          ]
        },
        {
          path: 'personalHome/todoList',
          name: '',
          component: bizHomeFrame,
          children: [
            {
              path: '',
              name: 'bizTodoListDefault',
              component: bizTodoListDefault,
              meta: {
                title: '待辦事項',
                channel: 'WEB_COMPANY',
              },
            },
            // {
            //   path: 'listMode',
            //   name: 'bizTodoListDefault',
            //   component: bizTodoListDefault,
            //   meta: {
            //     title: '待辦事項',
            //   },
            // },
          ]
        },
        {
          path: 'personalHome/recommandTenant',
          name: '',
          component: bizHomeFrame,
          children: [
            {
              path: '',
              name: 'bizRecommandTenant',
              component: () => import('@/pages/bussiness/personalHome/recommandTenant/recommandTenantDefault.vue'),
              meta: {
                title: '推薦房客',
                channel: 'WEB_COMPANY',
              },
            },
          ]
        },
        {
          path: 'mgtCategory/houseMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizHouseMgtDefault',
              component: bizHouseMgtDefault,
              meta: {
                title: '房源管理',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'addhouse',
              name: 'bizAddHouse',
              component: bizAddHouse,
              meta: {
                title: '刊登廣告',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                // isVerified: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '刊登廣告'
                  }
                ]
              },
            },
            {
              path: 'editHouse',
              name: 'bizEditHouse',
              component: bizEditHouse,
              meta: {
                title: '編輯房源',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '編輯房源'
                  }
                ]
              },
            },
            {
              path: 'editPolicy',
              name: 'bizEditPolicy',
              component: bizEditPolicy,
              meta: {
                title: '編輯合約條款',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '編輯合約條款'
                  }
                ]
              },
            },
            {
              path: 'batch',
              name: 'bizBatchUpload',
              component: bizBatchUpload,
              meta: {
                title: '批量刊登廣告',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '批量刊登廣告'
                  }
                ]
              },
            },
            {
              path: 'batchPolicy',
              name: 'bizBatchPolicy',
              component: bizBatchPolicy,
              meta: {
                title: '批量套用條款',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '批量套用條款'
                  }
                ]
              },
            },
            {
              path: 'batchPublish',
              name: 'bizBatchPublish',
              component: bizBatchPublish,
              meta: {
                title: '批量設定上架',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '批量設定上架'
                  }
                ]
              },
            },{
              path: 'batchDispatch',
              name: 'bizBatchDispatch',
              component: bizBatchDispatch,
              meta: {
                title: '批量分派房東與業務',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '批量分派房東與業務'
                  }
                ]
              },
            },
            {
              path: 'batchContractVersion',
              name: 'bizBatchContractVersion',
              component: () => import('@/pages/bussiness/mgtCategory/houseMgt/batchContractVersion.vue'),
              meta: {
                title: '批量套用合約版本',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '批量套用合約版本'
                  }
                ]
              },
            },
            {
              path: 'viewHouse',
              name: 'bizViewHouse',
              component: bizViewHouse,
              meta: {
                title: '查看房源',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源管理',
                    link: 'bizHouseMgtDefault'
                  },
                  {
                    name: '查看房源'
                  }
                ]
              },
            },
          ]
        },
        {
          path: 'mgtCategory/houseGroupMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizHouseGroupMgtDefault',
              component: bizHouseGroupMgtDefault,
              meta: {
                title: '房源群組',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'getHouseGroupList',
              name: 'bizEditHouseGroup',
              component: bizEditHouseGroup,
              meta: {
                title: '編輯房源群組',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '房源群組',
                    link: 'bizHouseGroupMgtDefault'
                  },
                  {
                    name: '編輯房源群組'
                  }
                ]
              },
            },
          ]
        },
        {
          path: 'mgtCategory/leaseMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizLeaseMgtDefault',
              component: bizLeaseMgtDefault,
              meta: {
                title: '租約管理',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'newPaperContract',
              name: 'bizNewPaperContract',
              component: bizNewPaperContract,
              meta: {
                title: '新增紙本合約',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '新增紙本合約'
                  }
                ]
              },
            },
            {
              path: 'newEContract',
              name: 'bizNewEContract',
              component: bizNewEContract,
              meta: {
                title: '新增電子合約',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '新增電子合約'
                  }
                ]
              },
            },
            {
              path: 'renewalContract',
              name: 'bizRenewalContract',
              component: () => import('@/pages/bussiness/mgtCategory/leaseMgt/renewalFrame.vue'),
              meta: {
                title: '續租',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '續租'
                  }
                ]
              },
            },
            {
              path: 'batchBill',
              name: 'bizBatchBill',
              component: () => import('@/pages/bussiness/mgtCategory/leaseMgt/batchBill.vue'),
              meta: {
                title: '批量新增帳單',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '批量新增帳單'
                  }
                ]
              },
            },
            {
              path: 'batchNotify',
              name: 'bizBatchNotify',
              component: bizBatchNotify,
              meta: {
                title: '通知設定',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '通知設定'
                  }
                ]
              },
            },
            {
              path: 'batchMeterNotify',
              name: 'bizBatchMeterNotify',
              component: () => import('@/pages/bussiness/mgtCategory/leaseMgt/batchMeterNotify.vue'),
              meta: {
                title: '通知房客拍表設定',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '通知房客拍表設定',
                  }
                ]
              },
            },
            {
              path: 'newBill',
              name: 'bizNewBill',
              component: bizNewBill,
              meta: {
                title: '新增帳單',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '新增帳單'
                  }
                ]
              },
            },
            {
              path: 'meterRecord',
              name: 'bizMeterRecord',
              component: () => import('@/pages/bussiness/mgtCategory/leaseMgt/meterRecord.vue'),
              meta: {
                title: '房客拍表紀錄',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '租約管理',
                    link: 'bizLeaseMgtDefault'
                  },
                  {
                    name: '房客拍表紀錄',
                  }
                ]
              },
            },
          ]
        },
        {
          path: 'mgtCategory/bookingMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizBookingMgtDefault',
              component: bizBookingMgtDefault,
              meta: {
                title: '預定管理',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },


          ]
        },
        {
          path: 'mgtCategory/taskMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizTaskMgtDefault',
              component: bizTaskMgtDefault,
              meta: {
                title: '委託房客',
                channel: 'WEB_COMPANY',
                isFixed: true
              }
            },
            {
              path: 'newTask',
              name: 'bizNewTask',
              component: bizNewTask,
              meta: {
                title: '新增委託',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '委託房客',
                    link: 'bizTaskMgtDefault'
                  },
                  {
                    name: '新增委託'
                  }
                ]
              },
            },
            {
              path: 'taskPayment',
              name: 'bizTaskPayment',
              component: bizTaskPayment,
              meta: {
                title: '委託付款',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '委託房客',
                    link: 'bizTaskMgtDefault'
                  },
                  {
                    name: '委託付款'
                  }
                ]
              }
            }
          ],
          meta: {
            isFixed: true,
          },

        },
        {
          path: 'mgtCategory/landlordMgt',
          name: '',
          component: bizMgtCategoryFrame,
          children: [
            {
              path: '',
              name: 'bizLandlordMgtDefault',
              component: bizLandlordMgtDefault,
              meta: {
                title: '屋主管理',
                channel: 'WEB_COMPANY',
                isFixed: true
              }
            },
            {
              path: 'addLandlord',
              name: 'bizAddLandlord',
              component: bizAddLandlord,
              meta: {
                title: '新增房東',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主管理',
                    link: 'bizLandlordMgtDefault'
                  },
                  {
                    name: '新增房東'
                  }
                ]
              },
            },
            {
              path: 'editLandlord',
              name: 'bizEditLandlord',
              component: bizEditLandlord,
              meta: {
                title: '編輯房東',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主管理',
                    link: 'bizLandlordMgtDefault'
                  },
                  {
                    name: '編輯房東'
                  }
                ]
              },

            },
            {
              path: 'viewLandlord',
              name: 'bizViewLandlord',
              component: bizViewLandlord,
              meta: {
                title: '查看屋主',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主管理',
                    link: 'bizLandlordMgtDefault'
                  },
                  {
                    name: '查看屋主'
                  }
                ]
              },

            },
          ],
          meta: {
            isFixed: true,
          },

        },
        {
          path: 'financialReport/',
          name: '',
          component: bizFinancialReportFrame,
          children: [
            {
              path: 'reportOverview',
              name: 'bizReportOverview',
              component: bizReportOverview,
              meta: {
                title: '報表概覽',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'billMgt',
              name: 'billMgt',
              component: bizBillMgt,
              meta: {
                title: '帳單管理',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'editBill',
              name: 'bizEditBill',
              component: bizEditBill,
              meta: {
                title: '編輯帳單',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '帳單管理',
                    link: 'billMgt'
                  },
                  {
                    name: '編輯帳單'
                  }
                ]
              },
            },
            {
              path: 'ledgerMgt',
              name: 'ledgerMgt',
              component: bizLedgerMgt,
              meta: {
                title: '記帳管理',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'newLedger',
              name: 'bizNewLedger',
              component: bizNewLedger,
              meta: {
                title: '新增記帳',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '記帳管理',
                    link: 'ledgerMgt'
                  },
                  {
                    name: '新增記帳'
                  }
                ]
              },
            },
            {
              path: 'editLedger',
              name: 'bizEditLedger',
              component: bizEditLedger,
              meta: {
                title: '編輯記帳',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '記帳管理',
                    link: 'ledgerMgt'
                  },
                  {
                    name: '編輯記帳'
                  }
                ]
              },
            },
            {
              path: 'landlordReport',
              name: 'landlordReport',
              component: () => import('@/pages/bussiness/financialReport/landlordReport/landlordReportDefault'),
              meta: {
                title: '屋主報表',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'landlordReportDetail',
              name: 'landlordReportDetail',
              component: () => import('@/pages/bussiness/financialReport/landlordReport/landlordReportDetail'),
              meta: {
                title: '物件報表',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主報表',
                    link: 'landlordReport'
                  },
                  {
                    name: '物件報表'
                  }
                ]
              },
            },
            {
              path: 'landlordReportHistory',
              name: 'landlordReportHistory',
              component: () => import('@/pages/bussiness/financialReport/landlordReport/landlordReportHistory'),
              meta: {
                title: '歷史報表',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主報表',
                    link: 'landlordReport'
                  },
                  {
                    name: '物件報表',
                  },
                  {
                    name: '歷史報表'
                  }
                ]
              },
            },
            {
              path: 'newLandlordReport',
              name: 'newLandlordReport',
              component: () => import('@/pages/bussiness/financialReport/landlordReport/newLandlordReport'),
              meta: {
                title: '建立報表',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主報表',
                    link: 'landlordReport'
                  },
                  {
                    name: '物件報表',
                  },
                  {
                    name: '歷史報表',
                  },
                  {
                    name: '建立報表',
                  }
                ]
              },
            },
            {
              path: 'editLandlordReport',
              name: 'editLandlordReport',
              component: () => import('@/pages/bussiness/financialReport/landlordReport/editLandlordReport'),
              meta: {
                title: '編輯報表',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '屋主報表',
                    link: 'landlordReport'
                  },
                  {
                    name: '物件報表',
                  },
                  {
                    name: '歷史報表',
                  },
                  {
                    name: '編輯報表',
                  }
                ]
              },
            }
          ]
        },
        {
          path: 'internalAuth/',
          name: '',
          component: bizInternalAuthFrame,
          children: [
            {
              path: 'employeeRole',
              name: 'bizEmployeeRole',
              component: bizEmployeeRoleDefault,
              meta: {
                title: '職務部門',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'employeeRole/addEmployeeRole',
              name: 'bizAddEmployeeRole',
              component: bizAddEmployeeRole,
              meta: {
                title: '新增職務部門',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '職務部門',
                    link: 'bizEmployeeRole'
                  },
                  {
                    name: '新增職務部門'
                  }
                ]
              },
            },
            {
              path: 'employeeRole/editEmployeeRole',
              name: 'bizEditEmployeeRole',
              component: bizEditEmployeeRole,
              meta: {
                title: '編輯職務部門',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '職務部門',
                    link: 'bizEmployeeRole'
                  },
                  {
                    name: '編輯職務部門'
                  }
                ]
              },
            },
            {
              path: 'employeeRole/viewEmployeeRole',
              name: 'bizViewEmployeeRole',
              component: bizViewEmployeeRole,
              meta: {
                title: '查看職務部門',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '職務部門',
                    link: 'bizEmployeeRole'
                  },
                  {
                    name: '查看職務部門'
                  }
                ]
              },
            },
            {
              path: 'accountMgt',
              name: 'bizAccountMgt',
              component: bizAccountMgtDefault,
              meta: {
                title: '員工帳號',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'accountMgt/addAccount',
              name: 'bizAddAccount',
              component: bizAddAccount,
              meta: {
                title: '新增帳號',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '員工帳號',
                    link: 'bizAccountMgt'
                  },
                  {
                    name: '新增帳號'
                  }
                ]
              },
            },
            {
              path: 'accountMgt/editAccount',
              name: 'bizEditAccount',
              component: bizEditAccount,
              meta: {
                title: '編輯帳號',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '員工帳號',
                    link: 'bizAccountMgt'
                  },
                  {
                    name: '編輯帳號'
                  }
                ]
              },

            },
            {
              path: 'accountMgt/viewAccount',
              name: 'bizViewAccount',
              component: bizViewAccount,
              meta: {
                title: '查看帳號',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '員工帳號',
                    link: 'bizAccountMgt'
                  },
                  {
                    name: '查看帳號'
                  }
                ]
              },

            },
            {
              path: 'organizationGroup',
              name: 'bizOrganizationGroup',
              component: bizOrganizationGroupDefault,
              meta: {
                title: '業務分群',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
              children: [
              ]
            },
            {
              path: 'organizationGroup/addOrganizationGroup',
              name: 'bizAddOrganizationGroup',
              component: bizAddOrganizationGroup,
              meta: {
                title: '新增業務分群',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '業務分群',
                    link: 'bizOrganizationGroup'
                  },
                  {
                    name: '新增業務分群'
                  }
                ]
              },
            },
            {
              path: 'organizationGroup/editOrganizationGroup',
              name: 'bizEditOrganizationGroup',
              component: bizEditOrganizationGroup,
              meta: {
                title: '編輯業務分群',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '業務分群',
                    link: 'bizOrganizationGroup'
                  },
                  {
                    name: '編輯業務分群'
                  }
                ]
              },
            },
          ]
        },
        {
          path: 'settingCenter/',
          name: '',
          component: bizSettingCenterFrame,
          children: [
            {
              path: 'enterpriseVerified',
              name: 'bizBussinessVerified',
              component: bizBussinessVerifiedDefault,
              meta: {
                title: '企業認證',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'enterpriseIntro',
              name: 'bizIntrolDefault',
              component: bizIntrolDefault,
              meta: {
                title: '企業簡介設定',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'contractSetting',
              name: 'bizContractSetting',
              component: bizContractSettingDefault,
              meta: {
                title: '編輯合約參數',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '設定合約',
                    link: 'bizContractVersion'
                  },
                  {
                    name: '編輯合約參數'
                  }
                ]
              },
            },
            {
              path: 'contractVersion',
              name: 'bizContractVersion',
              component: () => import('@/pages/bussiness/settingCenter/contractVersion/contractVersion'),
              meta: {
                title: '設定合約',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: false,
              },
            },
            {
              path: 'billChargeMode',
              name: 'billChargeMode',
              component: () => import('@/pages/bussiness/settingCenter/billChargeMode/billChargeMode'),
              meta: {
                title: '費用組合',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: false,
              },
            },
            {
              path: 'addBillChargeMode',
              name: 'addBillChargeMode',
              component: () => import('@/pages/bussiness/settingCenter/billChargeMode/addBillChargeMode'),
              meta: {
                title: '新增費用組合',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '費用組合',
                    link: 'billChargeMode'
                  },
                  {
                    name: '新增費用組合'
                  }
                ]
              },
            },
            {
              path: 'editBillChargeMode',
              name: 'editBillChargeMode',
              component: () => import('@/pages/bussiness/settingCenter/billChargeMode/editBillChargeMode'),
              meta: {
                title: '編輯費用組合',
                channel: 'WEB_COMPANY',
                isFixed: true,
                isBreadcrumb: true,
                breadcrumb: [
                  {
                    name: '費用組合',
                    link: 'billChargeMode'
                  },
                  {
                    name: '編輯費用組合'
                  }
                ]
              },
            },
            {
              path: 'wallet',
              name: 'bizWalletDefault',
              component: bizWalletDefault,
              meta: {
                title: '飛豬錢包',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
            {
              path: 'enterpriseReceipt',
              name: 'bizElectReceiptDefault',
              component: bizElectReceiptDefault,
              meta: {
                title: '電子發票',
                channel: 'WEB_COMPANY',
                isFixed: true,
              },
            },
          ]
        },
        {
          path: 'personalCenter/',
          name: '',
          component: bizPersonalCenterFrame,
          children: [
            {
              path: '',
              name: 'bizPersonalCenterDefault',
              component: bizPersonalCenterDefault,
              meta: {
                title: '個人中心',
                channel: 'WEB_COMPANY',
              },
            },
          ]
        },
        {
          path: 'faq',
          name: 'bizFaq',
          component: bizFaq,
          meta: {
            title: '常見問題',
            channel: 'WEB_COMPANY',
          }
        },
      ]
    },
    {
      path: '/enterprise/mgtCategory/bookingMgt/bizContract',
      name: 'bizContractDefault',
      component: bizContractDefault,
      meta: {
        title: '合約',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/enterprise/settingCenter/contractSetting/previewContract',
      name: 'bizPreviewContract',
      component: bizPreviewContract,
      meta: {
        title: '預覽合約',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/enterprise/settingCenter/contractVersion/addContract',
      name: 'bizAddContractVersion',
      component: () => import('@/pages/bussiness/settingCenter/contractVersion/addContract.vue'),
      meta: {
        title: '新增合約版本',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/enterprise/settingCenter/contractVersion/editContract',
      name: 'bizEditContractVersion',
      component: () => import('@/pages/bussiness/settingCenter/contractVersion/editContract .vue'),
      meta: {
        title: '編輯合約版本',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/enterprise/mgtCategory/houseMgt/previewHouse',
      name: 'previewHouse',
      component: shareHouse,
      meta: {
        title: '預覽房源',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/mapSearch',
      name: 'bizMapSearch',
      component: bizMapSearch,
      meta: {
        title: '地圖搜尋',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/experience/login',
      name: 'bizExperienceLogin',
      component: bizLogin,
      meta: {
        title: '企業體驗帳號登入',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/login',
      name: 'bizLogin',
      component: bizLogin,
      meta: {
        title: '企業登入',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/defaultPolicy',
      name: 'bizDefaultPolicy',
      component: bizDefaultPolicy,
      meta: {
        title: '預設政策',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/register',
      name: 'bizRegister',
      component: bizRegister,
      meta: {
        title: '註冊',
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/setPassword',
      name: 'bizSetPassword',
      component: bizSetPassword,
      meta: {
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/updateSecrectSuccess',
      name: 'bizUpdateSecrectSuccess',
      component: bizUpdateSecrectSuccess,
      meta: {
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/verifiedEmail',
      name: 'bizVerifiedEmail',
      component: bizVerifiedEmail,
      meta: {
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/enterprise/bizVerified',
      name: 'bizVerified',
      component: bizVerified,
      meta: {
        channel: 'WEB_COMPANY',
        // requiresAuth: true,
      },
    },
    {
      path: '/bizPhoneSigned',
      name: 'bizPhoneSigned',
      component: bizPhoneSigned,
      meta: {
        channel: 'WEB_COMPANY',
      },
    },
    {
      path: '/landlord/leasemanagement/contractVersion/addContract',
      name: 'addContractVersion',
      component: () => import('@/pages/landlord/LeaseManagementPages/addContract.vue'),
      meta: {
        title: '新增合約版本',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/landlord/leasemanagement/contractVersion/editContract',
      name: 'editContractVersion',
      component: () => import('@/pages/landlord/LeaseManagementPages/editContract.vue'),
      meta: {
        title: '編輯合約版本',
        channel: 'WEB_COMPANY',
        // isFixed: true,
      },
    },
    {
      path: '/mb/enterprise/',
      name: '',
      component: () => import('@/pages/mb/enterprise/index.vue'),
      meta: {
        requiresAuth: true,
      },
      children: [
        {
          path: '',
          name: 'myHome',
          component: () => import('@/pages/mb/enterprise/myHome/index.vue'),
          meta: {
            title: '飛豬管家',
            channel: 'WEB_COMPANY',
            requiresAuth: true,
          },
        },
        {
          path: 'uploadRecord/',
          name: 'uploadRecord',
          component: () => import('@/pages/mb/enterprise/uploadRecord/index.vue'),
          meta: {
            title: '上傳電表',
            channel: 'WEB_COMPANY',
            requiresAuth: true,
          },
        },
        {
          path: 'uploadRecord/filter',
          name: 'uploadRecordFilter',
          component: () => import('@/pages/mb/enterprise/uploadRecord/filter.vue'),
          meta: {
            title: '篩選',
            channel: 'WEB_COMPANY',
            requiresAuth: true,
          },
        },
        {
          path: 'uploadRecord/record',
          name: 'uploadRecordRecord',
          component: () => import('@/pages/mb/enterprise/uploadRecord/record.vue'),
          meta: {
            title: '上傳電表',
            channel: 'WEB_COMPANY',
            requiresAuth: true,
          },
        },
        {
          path: 'uploadRecord/upload',
          name: 'uploadRecordUpload',
          component: () => import('@/pages/mb/enterprise/uploadRecord/upload.vue'),
          meta: {
            channel: 'WEB_COMPANY',
            requiresAuth: true,
          },
        },
      ]
    },
  ],
  scrollBehavior() {
    window.scrollTo(0,0);
    // document.getElementById('app').scrollIntoView();
  }
})

router.beforeEach((to, from, next) => {
  //個人房東是否已認證
  let userVerifiedState = localStorage.getItem('userState')
  //更換網頁標題
  changeTitle(to)
  //企業認證信
  checkIsVerified(to, next)

  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn || store.getters.isBizLoggedIn) {
      // 個人房東頁面是否需審核才可觀看
      if(to.meta.isVerified){
        console.log('userVerifiedState', userVerifiedState)
        if( userVerifiedState == 'true' ){
          next()
          return
        }else{
          store.dispatch('setModalStatus', {state: true, type: 'verifiedAlarm'})
          return
        }
      }else{
        next()
        return
      }
    }else{
      console.log('route login')
      next('/')
    }

  } else {
    next()
  }

})

function changeTitle (to) {
  // console.log(to)
  if (to.meta.title) {
    document.title = to.meta.title
  }
}
function checkIsVerified (to, next) {
  if(to.query.verifyCode){
    // console.log('驗證')
    let data = {
      verificationCode: to.query.verifyCode
    };
    // console.log(data)
    store.dispatch('verification', data)
    .then(() => {
        next({ name: 'bizLogin'})
        let alarm = {
          status: true,
          title: '帳號驗證成功',
          description: null,
          type: 'success'
        }
        store.dispatch('setAlarmStatus', alarm)
    })
    .catch(() => {
      router.push({ name: 'bizLogin'})
      let alarm = {
        status: true,
        title: '系統發生未預期錯誤，請再試一次',
        description: null,
        type: 'error'
      }
      store.dispatch('setAlarmStatus', alarm)
    });
  }else{
    return
    // console.log('下一步')
    // next()
  }
}
export default router



// WEBPACK FOOTER //
// ./src/router/index.js